angular.module('LeasePilot').controller('TwoFactorController', [
  '$scope',
  '$http',
  '$mdToast',
  '$mdDialog',
  function($scope, $http, $mdToast, $mdDialog) {
    function showToast(message, type = "success") {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(message)
          .position("top right")
          .hideDelay(3000)
          .theme(type === "error" ? "error-toast" : "success-toast")
      );
    }

    $scope.enableTwoFactor = function() {
      $http.post('/api/two_factor/enable').then(function(response) {
        $mdDialog.show({
          templateUrl: 'qrCodeDialog.html',
          controller: ['$scope', '$mdDialog', '$http', 'qrCodeUrl', 'provisioningUri', 'otpSecret',
            function($scope, $mdDialog, $http, qrCodeUrl, provisioningUri, otpSecret) {
              $scope.qrCodeUrl = qrCodeUrl;
              $scope.provisioningUri = provisioningUri;
              $scope.otpSecret = otpSecret;
              
              $scope.cancel = function() {
                $mdDialog.cancel();
              };
              
              $scope.verify = function(otp) {
                if (!otp) {
                  document.getElementById('otp-error').style.display = 'block';
                  return;
                }
                
                document.getElementById('otp-error').style.display = 'none';
                
                $http.post('/api/two_factor/verify', { otp: otp }).then(function() {
                  $mdDialog.hide();
                  showToast('Two-factor authentication enabled successfully');
                  window.location.reload();
                }).catch(function() {
                  showToast('Invalid verification code. Please try again.', 'error');
                });
              };
            }
          ],
          locals: {
            qrCodeUrl: response.data.qr_code,
            provisioningUri: response.data.provisioning_uri,
            otpSecret: response.data.otp_secret 
          },
          clickOutsideToClose: false,
          fullscreen: false
        });
      }).catch(function(error) {
        showToast(error.data.error || 'Failed to enable two-factor authentication', 'error');
      });
    };

    $scope.disableTwoFactor = function() {
      if (!confirm('Are you sure you want to disable two-factor authentication? This will make your account less secure.')) {
        return;
      }

      $http.post('/api/two_factor/disable').then(function() {
        showToast('Two-factor authentication disabled successfully');
        window.location.reload();
      }).catch(function(error) {
        showToast(error.data.error || 'Failed to disable two-factor authentication', 'error');
      });
    };
  }
]); 